
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useCreateCreditPackageForOrder = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (orderId: string) => {
      console.log('Creating credit package for order:', orderId);

      const { data, error } = await supabase.rpc(
        'create_credit_package_for_completed_order',
        { order_id_param: orderId }
      );

      if (error) {
        console.error('Error creating credit package:', error);
        throw error;
      }

      return data;
    },
    onSuccess: (packageId, orderId) => {
      console.log('Credit package created successfully:', packageId);
      
      // Invalidate relevant queries
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      queryClient.invalidateQueries({ queryKey: ['enhanced-credit-packages'] });
      queryClient.invalidateQueries({ queryKey: ['device-assignment-audit'] });
      
      toast({
        title: "Success",
        description: "Credit package created successfully and is now available for allocation.",
      });
    },
    onError: (error: any) => {
      console.error("Error creating credit package:", error);
      
      let errorMessage = "Failed to create credit package. Please try again.";
      
      if (error.message?.includes('Credit packages already exist')) {
        errorMessage = "Credit packages already exist for this order.";
      } else if (error.message?.includes('Order not found or not completed')) {
        errorMessage = "Order must be completed before creating credit packages.";
      }
      
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    },
  });
};
